import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VeiculoVendidoDetalhadoComponent } from './veiculo-vendido-detalhado.component';
import { VeiculoVendidoDetalhadoService } from './veiculo-vendido-detalhado.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';
import { translateLoaderNBS } from '../../../shared/translate-loader/translateLoader';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ChartsModule } from 'ng2-charts';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { ComumModule } from '../../../shared/comum.module';
import { OsModule } from '../../rmpv/rmpv-detalhado-os/os.module';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    BrowserAnimationsModule,
    TableModule,
    ButtonModule,
    ToastModule,
    CalendarModule,
    DialogModule,
    DropdownModule,
    InputTextModule,
    FormsModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule,
    ChartsModule,
    OsModule,
    NgbModule,
    TranslateModule.forRoot(translateLoaderNBS),
    TooltipModule
  ],
  exports: [
    VeiculoVendidoDetalhadoComponent
  ],
  declarations: [
    VeiculoVendidoDetalhadoComponent
  ],
  providers: [
    VeiculoVendidoDetalhadoService
  ]
})
export class VeiculoVendidoDetalhadoModule { }
